import React from 'react';
import withAuth from '../../../hocs/withAuth';
import { Row, Col } from 'reactstrap';

import NavbarBusiness from '../../Components/BusinessNavbar';
import BusinessSidebar from '../../Components/BusinessSidebar';
import SectionBuildingSearch from './Sections/BuildingSearch';

// import './index.css';

function BuildingSearchPage(rest) {
	return (
		<div className='business-page-shell'>
			<NavbarBusiness />

			<Row className='g-0 no-gutters'>
				<Col xs='12' md='3' lg='3'>
					<BusinessSidebar />
				</Col>

				<Col xs='12' md='9' lg='9' className='business-page-shell__main'>
					<SectionBuildingSearch {...rest} />
				</Col>
			</Row>
		</div>
	);
}

export default withAuth(BuildingSearchPage);
